module.exports = __webpack_public_path__ + "img/4a95d4d979d54a1b995d9af0e7f46270.112a14d5.png";